import { PayloadAction } from "@reduxjs/toolkit";
import { EmployeesState } from "../../models/EmployeesState";
import { SendEmployeePasswordPayload } from "../../payload/SendEmployeePassword/SendEmployeePasswordPayload";

const sendPasswordFetch = (state: EmployeesState, action: PayloadAction<SendEmployeePasswordPayload>) => {
    state.isLoading = true;
}

export default sendPasswordFetch